import { reactive, ref, unref } from 'vue';
import { defineStore } from 'pinia'
import { useErrorHandling } from "../ErrorHandling";
import api from '../axios'

export const useBuyerStore = defineStore('buyer', () => {
  // States
  const profile = ref({})
  const authenticated = ref(false)
  const loading = ref(false)
  const token = ref('')
  const errors = reactive({
    getProfile: null,
    login: null,
    forgottenPassword: null,
    resetPassword: null,
  })

  token.value = localStorage.getItem('token');
  
  if(token.value != null) {
    api.defaults.headers.common["Authorization"] = "Bearer " + token.value;    
  }

  // Actions
  const getProfile = async () => {
    try {
      loading.value = true
      errors.getProfile = null
      const profileRes = await api.get('buyer/profile');
      profile.value = profileRes.data.user
      authenticated.value = true;
    } catch (error) {      
      errors.getProfile = useErrorHandling(error)
    } finally {
      loading.value = false
    }
  }

  const saveProfile = async (form) => {
    const formData = unref(form)
    try {
      loading.value = true
      errors.saveProfile = null
      const profileRes = await api.post('buyer/profile', formData);
      profile.value = profileRes.data.user
    } catch (error) {      
      errors.saveProfile = useErrorHandling(error)
    } finally {
      loading.value = false
    }
  }

  const login = async (form) => {
    const formData = unref(form)
    try {
      loading.value = true
      errors.login = null      
      const loginRes = await api.post('login', formData);
      token.value = loginRes.data.token;
      localStorage.setItem("token", token.value);
      api.defaults.headers.common["Authorization"] = "Bearer " + token.value;      
    } catch (error) {      
      errors.login = useErrorHandling(error)
    } finally {
      loading.value = false
    }
  }

  const logout = async () => {
    await api.post('logout');
    token.value = null;
    localStorage.removeItem("token");
    api.defaults.headers.common["Authorization"] = "Bearer " + token.value;
    authenticated.value = false;    
    profile.value = {};
  }

  const forgottenPassword = async (form) => {
    const formData = unref(form)
    try {
      loading.value = true
      errors.forgottenPassword = null      
      await api.post('forgot-password', formData);      
    } catch (error) {      
      errors.forgottenPassword = useErrorHandling(error)
    } finally {
      loading.value = false
    }
  }

  const resetPassword = async (form) => {
    const formData = unref(form)
    try {
      loading.value = true
      errors.resetPassword = null      
      await api.post('reset-password', formData);      
    } catch (error) {      
      errors.resetPassword = useErrorHandling(error)
    } finally {
      loading.value = false
    }
  }
  
  return {
    token,
    profile,
    authenticated,
    loading,
    errors,
    getProfile,
    saveProfile,
    login,
    logout,
    forgottenPassword,
    resetPassword
  }
})